"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var constants_1 = require("./constants");
var api_1 = require("../../utils/api");
var reducers = {
    collectionsById: api_1.createCustomModuleReducer(__assign(__assign({}, api_1.createApiReducer({
        actionType: constants_1.FETCH_COLLECTION,
        onSuccess: function (draftState, action) {
            var _a, _b, _c, _d, _e;
            var _f = action.meta, collectionId = _f.collectionId, isLoadMore = _f.isLoadMore;
            var collection = action.payload.collection;
            if (!isLoadMore || !draftState.data[collectionId]) {
                draftState.data[collectionId] = collection;
            }
            else {
                var targetCollection = draftState.data[collectionId];
                targetCollection.contentPage.pageInfo = (_a = collection === null || collection === void 0 ? void 0 : collection.contentPage) === null || _a === void 0 ? void 0 : _a.pageInfo;
                if (Array.isArray((_b = collection === null || collection === void 0 ? void 0 : collection.contentPage) === null || _b === void 0 ? void 0 : _b.content)) {
                    targetCollection.contentPage.content = ((_c = targetCollection === null || targetCollection === void 0 ? void 0 : targetCollection.contentPage) === null || _c === void 0 ? void 0 : _c.content) || [];
                    (_d = targetCollection.contentPage.content) === null || _d === void 0 ? void 0 : _d.push.apply(_d, (_e = collection === null || collection === void 0 ? void 0 : collection.contentPage) === null || _e === void 0 ? void 0 : _e.content);
                }
            }
        },
    })), api_1.createApiReducer({
        actionType: constants_1.FETCH_HOME_COLLECTION,
        onSuccess: function (draftState, action) {
            var collectionId = action.meta.collectionId;
            var collection = action.payload.collection;
            draftState.data[collectionId] = collection;
        },
    })), api_1.createApiInitialState({})),
    filtersById: api_1.createCustomModuleReducer((_a = {},
        _a[constants_1.SET_COLLECTION_FILTER] = function (draftState, action) {
            var _a;
            var _b = action.payload, collectionId = _b.collectionId, name = _b.name, value = _b.value;
            var collection = draftState.data[collectionId];
            if (collection) {
                collection[name] = value;
            }
            else {
                draftState.data[collectionId] = (_a = {}, _a[name] = value, _a);
            }
        },
        _a[constants_1.SET_COLLECTION_FILTERS] = function (draftState, action) {
            var _a = action.payload, collectionId = _a.collectionId, filters = _a.filters;
            draftState.data[collectionId] = __assign({}, filters);
        },
        _a[constants_1.CLEAR_COLLECTION_FILTERS] = function (draftState, action) {
            var collectionId = action.payload.collectionId;
            delete draftState.data[collectionId];
        },
        _a), api_1.createApiInitialState({})),
    browseCategories: api_1.createCustomModuleReducer(__assign({}, api_1.createApiReducer({
        actionType: constants_1.FETCH_BROWSE_CATEGORIES,
        onSuccess: api_1.createApiOnSuccessReducer(function (_, action) {
            var _a, _b;
            return (_b = (_a = action.payload.section) === null || _a === void 0 ? void 0 : _a.home) === null || _b === void 0 ? void 0 : _b.categories;
        }),
    })), api_1.createApiInitialState([])),
};
exports.default = redux_1.combineReducers(reducers);
//# sourceMappingURL=reducer.js.map